/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

import { TableSchema } from './metadata-schema';
import { Table } from './table';
import { bvn_basisvaardigheden_norm } from './tables/bvn_basisvaardigheden_norm';
import { dim_br_brin } from './tables/dim_br_brin';
import { dim_clc_cijfer_label_conversie } from './tables/dim_clc_cijfer_label_conversie';
import { dim_ilt_opleidingscode } from './tables/dim_ilt_opleidingscode';
import { dim_kl_klas } from './tables/dim_kl_klas';
import { dim_lg_lesgroep } from './tables/dim_lg_lesgroep';
import { dim_ll_leerling } from './tables/dim_ll_leerling';
import { dim_mw_medewerker } from './tables/dim_mw_medewerker';
import { dim_no_norm_onderwijsresultaat } from './tables/dim_no_norm_onderwijsresultaat';
import { dim_orvs_onderwijsresultaat_vestiging } from './tables/dim_orvs_onderwijsresultaat_vestiging';
import { dim_ov_onderwijspositie_vergelijkgroep } from './tables/dim_ov_onderwijspositie_vergelijkgroep';
import { dim_pc_postcode } from './tables/dim_pc_postcode';
import { dim_per_periode } from './tables/dim_per_periode';
import { dim_ppv_percentiel_prestatie_vso } from './tables/dim_ppv_percentiel_prestatie_vso';
import { dim_vk_vak } from './tables/dim_vk_vak';
import { dim_vs_vestiging } from './tables/dim_vs_vestiging';
import { dim_vv_vestiging_vak } from './tables/dim_vv_vestiging_vak';
import { fac_af_afspraak } from './tables/fac_af_afspraak';
import { fac_aw_aanwezigheid } from './tables/fac_aw_aanwezigheid';
import { fac_bv_basisvaardigheden } from './tables/fac_bv_basisvaardigheden';
import { fac_cf_cijfer } from './tables/fac_cf_cijfer';
import { fac_ck_cijferkolommen } from './tables/fac_ck_cijferkolommen';
import { fac_ds_doorstroom } from './tables/fac_ds_doorstroom';
import { fac_ekc_examenkandidaten_en_cijfers } from './tables/fac_ekc_examenkandidaten_en_cijfers';
import { fac_lb_loopbaan } from './tables/fac_lb_loopbaan';
import { fac_lr_lesregistratie } from './tables/fac_lr_lesregistratie';
import { fac_or_onderwijsresultaten } from './tables/fac_or_onderwijsresultaten';
import { fac_pv_prestatieanalyse_vso } from './tables/fac_pv_prestatieanalyse_vso';
import { fac_vkk_vakkeuze } from './tables/fac_vkk_vakkeuze';
import { instelling } from './tables/instelling';
import { la_leerling_autorisatie } from './tables/la_leerling_autorisatie';
import { vest_cluster_vso } from './tables/vest_cluster_vso';

export const tableSchemaMap: Record<Table, TableSchema> = {
	[Table.bvn_basisvaardigheden_norm]: bvn_basisvaardigheden_norm,
	[Table.dim_br_brin]: dim_br_brin,
	[Table.dim_clc_cijfer_label_conversie]: dim_clc_cijfer_label_conversie,
	[Table.dim_ilt_opleidingscode]: dim_ilt_opleidingscode,
	[Table.dim_kl_klas]: dim_kl_klas,
	[Table.dim_lg_lesgroep]: dim_lg_lesgroep,
	[Table.dim_ll_leerling]: dim_ll_leerling,
	[Table.dim_mw_medewerker]: dim_mw_medewerker,
	[Table.dim_no_norm_onderwijsresultaat]: dim_no_norm_onderwijsresultaat,
	[Table.dim_orvs_onderwijsresultaat_vestiging]: dim_orvs_onderwijsresultaat_vestiging,
	[Table.dim_ov_onderwijspositie_vergelijkgroep]: dim_ov_onderwijspositie_vergelijkgroep,
	[Table.dim_pc_postcode]: dim_pc_postcode,
	[Table.dim_per_periode]: dim_per_periode,
	[Table.dim_ppv_percentiel_prestatie_vso]: dim_ppv_percentiel_prestatie_vso,
	[Table.dim_vk_vak]: dim_vk_vak,
	[Table.dim_vs_vestiging]: dim_vs_vestiging,
	[Table.dim_vv_vestiging_vak]: dim_vv_vestiging_vak,
	[Table.fac_af_afspraak]: fac_af_afspraak,
	[Table.fac_aw_aanwezigheid]: fac_aw_aanwezigheid,
	[Table.fac_bv_basisvaardigheden]: fac_bv_basisvaardigheden,
	[Table.fac_cf_cijfer]: fac_cf_cijfer,
	[Table.fac_ck_cijferkolommen]: fac_ck_cijferkolommen,
	[Table.fac_ds_doorstroom]: fac_ds_doorstroom,
	[Table.fac_ekc_examenkandidaten_en_cijfers]: fac_ekc_examenkandidaten_en_cijfers,
	[Table.fac_lb_loopbaan]: fac_lb_loopbaan,
	[Table.fac_lr_lesregistratie]: fac_lr_lesregistratie,
	[Table.fac_or_onderwijsresultaten]: fac_or_onderwijsresultaten,
	[Table.fac_pv_prestatieanalyse_vso]: fac_pv_prestatieanalyse_vso,
	[Table.fac_vkk_vakkeuze]: fac_vkk_vakkeuze,
	[Table.instelling]: instelling,
	[Table.la_leerling_autorisatie]: la_leerling_autorisatie,
	[Table.vest_cluster_vso]: vest_cluster_vso
};
